import { Box,Typography } from '@mui/material'
import React from 'react'
import BankCard from '../../Components/UI/BankCard'

export default function Hospital() {
  //https://www.sonalibank.com.bd/
  //https://www.jb.com.bd/
  return (
    <Box sx={{width:"100vw",minHeight:"100vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",margin:{md:"7vh"}}}>
        <Box sx={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"15vh",marginTop:{xs:"3vh",md:"7vh"},textAlign:"center"}}>
            <Typography variant="h4" color="primary" sx={{maxWidth:"80vw"}}>Astha Education partners</Typography>
            <Typography variant="p" sx={{maxWidth:"80vw"}}>See all our partners who provide you education services</Typography>
        </Box>
        <Box sx={{display:"flex" ,width:{xs:"80vw",md:"80vw"},flexDirection:{xs:"column",md:"row"},flexWrap:"wrap",alignItems:"center",justifyContent:"space-around",height:"70vh"}}>
          <BankCard name="Coxs Bazar International School" icon="https://i.postimg.cc/Y00k03qW/School-512.webp" color="#000000" />
          <BankCard name="কক্সবাজার সরকারি উচ্চ বিদ্যালয়" icon="https://i.postimg.cc/Y00k03qW/School-512.webp" color="#000000"/>
          <BankCard name="P.M.Khali High School" icon="https://i.postimg.cc/Y00k03qW/School-512.webp" color="#000000"/>
          <BankCard name="Ananda Multimedia School" icon="https://i.postimg.cc/Y00k03qW/School-512.webp" color="#000000"/>
        </Box>
    </Box>
  )
}
